import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Swal from 'sweetalert2'
import * as anchor from '@project-serum/anchor';
import {
  resolveToWalletAddress,
  getParsedNftAccountsByOwner,
  createConnectionConfig,
} from "@nfteyez/sol-rayz";
import './Home.css';
import logo from './assets/logo.svg';
import mintGIF from './assets/mint.gif';
import twitter from './assets/footerTwitter.svg';
import facebook from './assets/facebook.svg';
import instagram from './assets/instagram.svg';
import linkedin from './assets/linkedin.svg';

import { useGlobalState } from './state';

import styled from 'styled-components';
import { FaAngleUp } from 'react-icons/fa';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {
  Commitment,
  Connection,
  PublicKey,
  Transaction,
} from '@solana/web3.js';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletDialogButton } from '@solana/wallet-adapter-material-ui';
import { WalletDisconnectButton } from '@solana/wallet-adapter-material-ui';
import {
  awaitTransactionSignatureConfirmation,
  CANDY_MACHINE_PROGRAM,
  CandyMachineAccount,
  createAccountsForMint,
  getCandyMachineState,
  getCollectionPDA,
  mintOneToken,
  mintMultipleToken,
  SetupState,
} from './candy-machine';
import { AlertState, getAtaForMint, toDate } from './utils';
import { MintButton } from './MintButton';
import { GatewayProvider } from '@civic/solana-gateway-react';
import { sendTransaction } from './connection';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import Hero from './components/Hero/Hero.js';
import Navbar from './components/Navbar/Navbar';
import Tokenomics from './components/Tokenomics/Tokenomics';
import Building from './components/Building/Building';
import Mission from './components/Mission/Mission';
import About from './components/About/About';
import Performers from './components/Performers/Performers';
import Roadmap from './components/Roadmap/Roadmap';
import Team from './components/Team/Team';
import Footer from './components/Footer/Footer';
import HeroNew from './components/HeroNew/HeroNew';
import NavbarNew from './components/NavbarNew/NavbarNew';
require('@solana/wallet-adapter-react-ui/styles.css');

export const WalletDisconnectButtonStyled = styled(WalletDisconnectButton)`
    background: linear-gradient(180deg, #D63648 0%, #D63648 100%);
    height: 50px;
    img {
        transform: rotate(0deg);
        filter: none;
        width: auto;
    }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: var(--primary-background);
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  h2 {
    font-family: 'Circular-Std', sans-serif;
    font-weight: 700;
    color: #676767;
    font-size: clamp(1rem, 1rem + 1.5vw, 7rem);
  }
  p {
    font-family: 'Circular-Std', sans-serif;
    font-size: clamp(1rem, 0.5rem + 0.5vw, 7rem);
  }
  h5 {
    font-family: 'Circular-Std', sans-serif;
    font-size: 1.2rem;
    padding: 30px;
  }
  h6 {
    font-family: 'Circular-Std', sans-serif;
    font-size: clamp(0.8rem, 0.7rem + 0.7vw, 7rem);
  }
  .line {
    border: 6px solid #FCC615;
    height: 1px;
    background-color: #FCC615;
    width: 180px;
    margin-bottom: 30px;
  }
  .background-hex {
    position: absolute;
    width: 100%;
    height: 100%;
    img {
      position: absolute;
    }
    img:nth-child(1) {
      right: 10%;
      top: 10%;
    }
    img:nth-child(2) {
      bottom: 20%;
      left: 5%;
    }
    img:nth-child(3) {
      left: 10%;
    }
    img:nth-child(4) {
      right: 5%;
      bottom: 40%;
    }
  }
  @media screen and (max-width: 1050px) {
    .line {
      border: 3px solid #FCC615;
      width: 100px;
    }
    .background-hex {
      display: none;
    }
  }
`;

export const MintNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 75%;
  .display-quantity {
    background-color: #ecf0f1;
    width: 60%;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
  }
  button {
    border: none;
    outline: none;
    width: 45px;
    height: 45px;
    border-radius: 5px;
    color: #fff;
    font-family: 'Monsterrat-Bold', sans-serif;
    font-weight: 700;
    font-size: 1rem;
    background-color: #D63648;
    :hover {
      cursor: pointer;
    }
  }
  @media screen and (max-width: 1050px) {
    margin-bottom: 20px;
  }
  @media screen and (max-width: 560px) {
    width: 90%;
  }
`;

export const PaperWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1150px;
  width: 100%;
  h1 {
    font-family: 'Monsterrat-ExtraBold', sans-serif;
    color: #676767;
    font-size: 4.6rem;
  }
  h3 {
    font-family: 'Monsterrat-Bold', sans-serif;
    color: #3A3D40;
    font-size: 1.25rem;
  }
  img {
    max-width: 500px;
  }
  .image-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 500px;
    padding-bottom: 30px;
  }
  @media screen and (max-width: 1050px) {
    flex-direction: column;
    margin-top: 30px;
    img {
      width: 40%;
      margin-top: 3em;
    }
    h1 {
      font-size: clamp(1rem, 4rem + 1vw, 3rem);
    }
    h3 {
      font-size: clamp(1rem, 0.7rem + 0.5vw, 3rem);
    }
  }
  @media screen and (max-width: 560px) {
    h3 {
      font-size: 0.8rem;
    }
    img {
      width: 80%;
    }
  }
  @media screen and (min-width: 1920px) {
    max-width: 1350px;
    h1 {
      font-size: 5.6rem;
    }
    img {
      max-width: 600px;
    }
  }
`;

export const PaperMint = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 52%;
  justify-content: space-between;
  min-height: 500px;
  @media screen and (max-width: 1050px) {
    width: 90%;
    align-items: center;
    min-height: 550px;
  }
  @media screen and (min-width: 1920px) {
    min-height: 570px;
  }
`;

const PaperStyled = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  input {
    width: 75%;
    height: 100%;
    border: none;
    outline: none;
    padding: 10px;
    padding-left: 20px;
    background-color: #ecf0f1;
    height: 35px;
    color: #000;
    :focus {
      border: none;
      outline: none;
    }
  }
  @media screen and (max-width: 1050px) {
    width: 100%;
    flex-direction: column;
  }
  @media screen and (max-width: 560px) {
    input {
      width: 90%;
    }
  }
`;

export const MintNavbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1150px;
  width: 100%;
  .navbar-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 400px;
  }
  .navbar-socials {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 50%;
  }
  @media screen and (max-width: 1050px) {
    flex-direction: column;
    .navbar-wrapper {
      width: 90%;
    }
    .navbar-socials {
      max-width: 200px;
    }
  }
  @media screen and (max-width: 380px) {
    .navbar-wrapper {
      flex-direction: column;
      width: 100%;
    }
    .navbar-socials {
      margin-bottom: 20px;
    }
  }
  @media screen and (min-width: 1920px) {
    max-width: 1350px;
  }
`;

const MintContainer = styled.div`

`; // add your owns styles here

export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
  network: WalletAdapterNetwork;
}

const Home = (props: HomeProps) => {
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: '',
    severity: undefined,
  });
  const [isActive, setIsActive] = useState(false);
  const [endDate, setEndDate] = useState<Date>();
  const [itemsRemaining, setItemsRemaining] = useState<number>();
  const [isWhitelistUser, setIsWhitelistUser] = useState(false);
  const [isPresale, setIsPresale] = useState(false);
  const [isValidBalance, setIsValidBalance] = useState(false);
  const [discountPrice, setDiscountPrice] = useState<anchor.BN>();
  const [needTxnSplit, setNeedTxnSplit] = useState(true);
  const [setupTxn, setSetupTxn] = useState<SetupState>();
  const [nftData, setNftData] = useState(0);
  const [darkMode] = useGlobalState("darkMode");

  const rpcUrl = props.rpcHost;
  const wallet = useWallet();

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const refreshCandyMachineState = useCallback(
    async (commitment: Commitment = 'confirmed') => {
      if (!anchorWallet) {
        return;
      }

      const connection = new Connection(props.rpcHost, commitment);

      if (props.candyMachineId) {
        try {
          const cndy = await getCandyMachineState(
            anchorWallet,
            props.candyMachineId,
            connection,
          );
          let active =
            cndy?.state.goLiveDate?.toNumber() < new Date().getTime() / 1000;
          let presale = false;

          // duplication of state to make sure we have the right values!
          let isWLUser = false;
          let userPrice = cndy.state.price;

          // whitelist mint?
          if (cndy?.state.whitelistMintSettings) {
            // is it a presale mint?
            if (
              cndy.state.whitelistMintSettings.presale &&
              (!cndy.state.goLiveDate ||
                cndy.state.goLiveDate.toNumber() > new Date().getTime() / 1000)
            ) {
              presale = true;
            }
            // is there a discount?
            if (cndy.state.whitelistMintSettings.discountPrice) {
              setDiscountPrice(cndy.state.whitelistMintSettings.discountPrice);
              userPrice = cndy.state.whitelistMintSettings.discountPrice;
            } else {
              setDiscountPrice(undefined);
              // when presale=false and discountPrice=null, mint is restricted
              // to whitelist users only
              if (!cndy.state.whitelistMintSettings.presale) {
                cndy.state.isWhitelistOnly = true;
              }
            }
            // retrieves the whitelist token
            const mint = new anchor.web3.PublicKey(
              cndy.state.whitelistMintSettings.mint,
            );
            const token = (
              await getAtaForMint(mint, anchorWallet.publicKey)
            )[0];

            try {
              const balance = await connection.getTokenAccountBalance(token);
              isWLUser = parseInt(balance.value.amount) > 0;
              // only whitelist the user if the balance > 0
              setIsWhitelistUser(isWLUser);

              if (cndy.state.isWhitelistOnly) {
                active = isWLUser && (presale || active);
              }
            } catch (e) {
              setIsWhitelistUser(false);
              // no whitelist user, no mint
              if (cndy.state.isWhitelistOnly) {
                active = false;
              }
              console.log(
                'There was a problem fetching whitelist token balance',
              );
              console.log(e);
            }
          }
          userPrice = isWLUser ? userPrice : cndy.state.price;

          if (cndy?.state.tokenMint) {
            // retrieves the SPL token
            const mint = new anchor.web3.PublicKey(cndy.state.tokenMint);
            const token = (
              await getAtaForMint(mint, anchorWallet.publicKey)
            )[0];
            try {
              const balance = await connection.getTokenAccountBalance(token);

              const valid = new anchor.BN(balance.value.amount).gte(userPrice);

              // only allow user to mint if token balance >  the user if the balance > 0
              setIsValidBalance(valid);
              active = active && valid;
            } catch (e) {
              setIsValidBalance(false);
              active = false;
              // no whitelist user, no mint
              console.log('There was a problem fetching SPL token balance');
              console.log(e);
            }
          } else {
            const balance = new anchor.BN(
              await connection.getBalance(anchorWallet.publicKey),
            );
            const valid = balance.gte(userPrice);
            setIsValidBalance(valid);
            active = active && valid;
          }

          // datetime to stop the mint?
          if (cndy?.state.endSettings?.endSettingType.date) {
            setEndDate(toDate(cndy.state.endSettings.number));
            if (
              cndy.state.endSettings.number.toNumber() <
              new Date().getTime() / 1000
            ) {
              active = false;
            }
          }
          // amount to stop the mint?
          if (cndy?.state.endSettings?.endSettingType.amount) {
            let limit = Math.min(
              cndy.state.endSettings.number.toNumber(),
              cndy.state.itemsAvailable,
            );
            if (cndy.state.itemsRedeemed < limit) {
              setItemsRemaining(limit - cndy.state.itemsRedeemed);
            } else {
              setItemsRemaining(0);
              cndy.state.isSoldOut = true;
            }
          } else {
            setItemsRemaining(cndy.state.itemsRemaining);
          }

          if (cndy.state.isSoldOut) {
            active = false;
          }

          const [collectionPDA] = await getCollectionPDA(props.candyMachineId);
          const collectionPDAAccount = await connection.getAccountInfo(
            collectionPDA,
          );

          setIsActive((cndy.state.isActive = active));
          setIsPresale((cndy.state.isPresale = presale));
          setCandyMachine(cndy);

          const txnEstimate =
            892 +
            (!!collectionPDAAccount && cndy.state.retainAuthority ? 182 : 0) +
            (cndy.state.tokenMint ? 66 : 0) +
            (cndy.state.whitelistMintSettings ? 34 : 0) +
            (cndy.state.whitelistMintSettings?.mode?.burnEveryTime ? 34 : 0) +
            (cndy.state.gatekeeper ? 33 : 0) +
            (cndy.state.gatekeeper?.expireOnUse ? 66 : 0);

          setNeedTxnSplit(txnEstimate > 1230);
        } catch (e) {
          if (e instanceof Error) {
            if (
              e.message === `Account does not exist ${props.candyMachineId}`
            ) {
              setAlertState({
                open: true,
                message: `Couldn't fetch candy machine state from candy machine with address: ${props.candyMachineId}, using rpc: ${props.rpcHost}! You probably typed the REACT_APP_CANDY_MACHINE_ID value in wrong in your .env file, or you are using the wrong RPC!`,
                severity: 'error',
                hideDuration: null,
              });
            } else if (
              e.message.startsWith('failed to get info about account')
            ) {
              setAlertState({
                open: true,
                message: `Couldn't fetch candy machine state with rpc: ${props.rpcHost}! This probably means you have an issue with the REACT_APP_SOLANA_RPC_HOST value in your .env file, or you are not using a custom RPC!`,
                severity: 'error',
                hideDuration: null,
              });
            }
          } else {
            setAlertState({
              open: true,
              message: `${e}`,
              severity: 'error',
              hideDuration: null,
            });
          }
          console.log(e);
        }
      } else {
        setAlertState({
          open: true,
          message: `Your REACT_APP_CANDY_MACHINE_ID value in the .env file doesn't look right! Make sure you enter it in as plain base-58 address!`,
          severity: 'error',
          hideDuration: null,
        });
      }
    },
    [anchorWallet, props.candyMachineId, props.rpcHost],
  );

  

  const onMint = 
  
  async (
    beforeTransactions: Transaction[] = [],
    afterTransactions: Transaction[] = [],
  ) => 
  {
    if(nftData <= 9) {
    try {
      setIsUserMinting(true);
      document.getElementById('#identity')?.click();
      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        let setupMint: SetupState | undefined;
        if (needTxnSplit && setupTxn === undefined) {
          setAlertState({
            open: true,
            message: 'Please sign account setup transaction',
            severity: 'info',
          });
          setupMint = await createAccountsForMint(
            candyMachine,
            wallet.publicKey,
          );
          let status: any = { err: true };
          if (setupMint.transaction) {
            status = await awaitTransactionSignatureConfirmation(
              setupMint.transaction,
              props.txTimeout,
              props.connection,
              true,
            );
          }
          if (status && !status.err) {
            setSetupTxn(setupMint);
            setAlertState({
              open: true,
              message:
                'Setup transaction succeeded! Please sign minting transaction',
              severity: 'info',
            });
          } else {
            setAlertState({
              open: true,
              message: 'Mint failed! Please try again!',
              severity: 'error',
            });
            setIsUserMinting(false);
            return;
          }
        } else {
          setAlertState({
            open: true,
            message: 'Please sign minting transaction',
            severity: 'info',
          });
        }

        let mintResult = 
          await mintOneToken(
          candyMachine,
          wallet.publicKey,
          beforeTransactions,
          afterTransactions,
          setupMint ?? setupTxn,
        )

        let status: any = { err: true };
        let metadataStatus = null;
        if (mintResult) {
          status = await awaitTransactionSignatureConfirmation(
            mintResult.mintTxId,
            props.txTimeout,
            props.connection,
            true,
          );

          metadataStatus =
            await candyMachine.program.provider.connection.getAccountInfo(
              mintResult.metadataKey,
              'processed',
            );
          console.log('Metadata status: ', !!metadataStatus);
        } 

        if (status && !status.err && metadataStatus) {
          // manual update since the refresh might not detect
          // the change immediately
          let remaining = itemsRemaining! - 1;
          setItemsRemaining(remaining);
          setIsActive((candyMachine.state.isActive = remaining > 0));
          candyMachine.state.isSoldOut = remaining === 0;
          setSetupTxn(undefined);
          setAlertState({
            open: true,
            message: 'Congratulations! Mint succeeded!',
            severity: 'success',
            hideDuration: 7000,
          });
          refreshCandyMachineState('processed');
        } else if (status && !status.err) {
          setAlertState({
            open: true,
            message:
              'Mint likely failed! Anti-bot SOL 0.01 fee potentially charged! Check the explorer to confirm the mint failed and if so, make sure you are eligible to mint before trying again.',
            severity: 'error',
            hideDuration: 8000,
          });
          refreshCandyMachineState();
        } else {
          setAlertState({
            open: true,
            message: 'Mint failed! Please try again!',
            severity: 'error',
          });
          refreshCandyMachineState();
        }
      }
    } catch (error: any) {
      let message = error.msg || 'Minting failed! Please try again!';
      let severity = error.severity || 'error';
      if (!error.msg) {
        if (!error.message) {
          message = 'Transaction timeout! Please try again.';
        } else if (error.message.indexOf('0x137')) {
          console.log(error);
          message = `Congratulations! Mint succeeded!`;
          severity = "success";
        } else if (error.message.indexOf('0x135')) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          console.log(error);
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }
    
    

      setAlertState({
        open: true,
        message,
        severity,
      });
      // updates the candy machine state to reflect the latest
      // information on chain
      refreshCandyMachineState();
    } finally {
      setIsUserMinting(false);
      getBalance();
    }
    } else {
      Swal.fire({
        title: 'LIMIT REACHED!',
        text: `You've already minted ${nftData} NFTs and cannot mint more.`,
        icon: 'error',
      })
    }
  };


  const toggleMintButton = () => {
    let active = !isActive || isPresale;

    if (active) {
      if (candyMachine!.state.isWhitelistOnly && !isWhitelistUser) {
        active = false;
      }
      if (endDate && Date.now() >= endDate.getTime()) {
        active = false;
      }
    }

    if (
      isPresale &&
      candyMachine!.state.goLiveDate &&
      candyMachine!.state.goLiveDate.toNumber() <= new Date().getTime() / 1000
    ) {
      setIsPresale((candyMachine!.state.isPresale = false));
    }

    setIsActive((candyMachine!.state.isActive = active));
  };

  useEffect(() => {
    refreshCandyMachineState();
  }, [
    anchorWallet,
    props.candyMachineId,
    props.connection,
    refreshCandyMachineState,
  ]);

  useEffect(() => {
    (function loop() {
      setTimeout(() => {
        refreshCandyMachineState();
        loop();
      }, 20000);
    })();
  }, [refreshCandyMachineState]);

  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
        if (window.scrollY > 400) {
            setShowTopBtn(true);
        } else {
            setShowTopBtn(false);
        }
    });
  }, []);

  const getBalance = async () => {
    try {
      // const address = "3EqUrFrjgABCWAnqMYjZ36GcktiwDtFdkNYwY6C6cDzy;
      // or use Solana Domain
        const connection = createConnectionConfig(rpcUrl)

        const walletAddressUser = wallet.publicKey?.toString();
    
        const nftArray = await getParsedNftAccountsByOwner({
          publicAddress: walletAddressUser!,
          connection
        });

        const newArray = nftArray.filter(function (el)
        {
          return el.data.symbol === 'TT';
        })

        setNftData(newArray.length)
      } catch (error) {
          console.log("Error thrown, while fetching NFTs");
      }
    }

  const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
  };

  const TopButton = styled.button`
    position: fixed;
    bottom: 20px;
    right: 20px;
  `;

  if(wallet.connected) {
    getBalance();
    return (
      <MainContainer style={{backgroundColor: darkMode ? '#101111' : '#fff', color: darkMode ? '#fff' : ''}}>
          <MintNavbar>
            <h5>ToritosToons</h5>
            <div className='navbar-wrapper'>
              <div className="navbar-socials">
                <a href="/">
                  <img src={twitter} alt="twitter" />
                </a>
                <a href="/">
                  <img src={instagram} alt="instagram" />
                </a>
                <a href="/">
                  <img src={facebook} alt="facebook" />
                </a>
                <a href="/">
                  <img src={linkedin} alt="linkedin" />
                </a>
              </div>
              <WalletDisconnectButtonStyled />
            </div>
          </MintNavbar>
          <PaperWrapper>
          <PaperMint>
          <h1 style={{color: darkMode ? '#fff' : ''}}>{`${itemsRemaining}`}/1000</h1>
          <h3 style={{color: darkMode ? '#d3d3d3' : ''}}>PUBLIC FREE MINT | MAX 10 PER WALLET</h3>
          <h3 style={{color: darkMode ? '#d3d3d3' : ''}}>*If you haven't minted any before, mint just 1 to start, after that you can only mint 10 NFTs per wallet.</h3>
              <PaperStyled>
              <MintContainer>
                {candyMachine?.state.isActive &&
                candyMachine?.state.gatekeeper &&
                wallet.publicKey &&
                wallet.signTransaction ? (
                  <GatewayProvider
                    wallet={{
                      publicKey:
                        wallet.publicKey ||
                        new PublicKey(CANDY_MACHINE_PROGRAM),
                      //@ts-ignore
                      signTransaction: wallet.signTransaction,
                    }}
                    gatekeeperNetwork={
                      candyMachine?.state?.gatekeeper?.gatekeeperNetwork
                    }
                    clusterUrl={
                      props.network === WalletAdapterNetwork.Devnet
                        ? 'https://api.devnet.solana.com'
                        : rpcUrl
                    }
                    handleTransaction={async (transaction: Transaction) => {
                      setIsUserMinting(true);
                      const userMustSign = transaction.signatures.find(sig =>
                        sig.publicKey.equals(wallet.publicKey!),
                      );
                      if (userMustSign) {
                        setAlertState({
                          open: true,
                          message: 'Please sign one-time Civic Pass issuance',
                          severity: 'info',
                        });
                        try {
                          transaction = await wallet.signTransaction!(
                            transaction,
                          );
                        } catch (e) {
                          setAlertState({
                            open: true,
                            message: 'User cancelled signing',
                            severity: 'error',
                          });
                          // setTimeout(() => window.location.reload(), 2000);
                          setIsUserMinting(false);
                          throw e;
                        }
                      } else {
                        setAlertState({
                          open: true,
                          message: 'Refreshing Civic Pass',
                          severity: 'info',
                        });
                      }
                      try {
                        await sendTransaction(
                          props.connection,
                          wallet,
                          transaction,
                          [],
                          true,
                          'confirmed',
                        );
                        setAlertState({
                          open: true,
                          message: 'Please sign minting',
                          severity: 'info',
                        });
                      } catch (e) {
                        setAlertState({
                          open: true,
                          message:
                            'Solana dropped the transaction, please try again',
                          severity: 'warning',
                        });
                        console.error(e);
                        // setTimeout(() => window.location.reload(), 2000);
                        setIsUserMinting(false);
                        throw e;
                      }
                      await onMint();
                    }}
                    broadcastTransaction={false}
                    options={{ autoShowModal: false }}
                  >
                    <MintButton
                      candyMachine={candyMachine}
                      isMinting={isUserMinting}
                      setIsMinting={val => setIsUserMinting(val)}
                      onMint={onMint}
                      isActive={
                        isActive ||
                        (isPresale && isWhitelistUser && isValidBalance)
                      }
                    />
                  </GatewayProvider>
                ) : (
                  <MintButton
                    candyMachine={candyMachine}
                    isMinting={isUserMinting}
                    setIsMinting={val => setIsUserMinting(val)}
                    onMint={onMint}
                    isActive={
                      isActive ||
                      (isPresale && isWhitelistUser && isValidBalance)
                    }
                  />
                )}
              </MintContainer>
              </PaperStyled>
              <h3 style={{color: darkMode ? '#d3d3d3' : ''}}>COMMUNITY LED PROJECT. YES, THERE IS ROADMAP.</h3>
              <h3 style={{color: darkMode ? '#d3d3d3' : ''}}>THERE'S A DISCORD AND YES WE WANT REAL WORLD UTILITY.</h3>
              <h3 style={{color: darkMode ? '#d3d3d3' : ''}}>THE WORLD IS OURS.</h3>
              <h3 style={{color: darkMode ? '#d3d3d3' : ''}}>333 RESERVED FOR THE TEAM.</h3>
              
          </PaperMint>
          <div className="image-div">
            <h2 style={{color: darkMode ? '#fff' : '', padding: '10px'}}>Your Balance : {nftData}</h2>
            <img src={mintGIF} alt="mintGIF" />
          </div>
          </PaperWrapper>
        <Snackbar
        open={alertState.open}
        autoHideDuration={
          alertState.hideDuration === undefined ? 6000 : alertState.hideDuration
        }
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
      </MainContainer>
      
    )
  }
  else {
  return (
    <Container>
      {/* 
      <div className='hero-wrapper'>
        <Navbar />
        <Hero />
      </div>
      <Tokenomics />
      <Building />
      <Mission />
      <About />
      <Performers />
      <Roadmap />
      <Team />
      <Footer />
      <div className="top-to-btm">
        {" "}
          {showTopBtn && (
            <FaAngleUp
                className="icon-position icon-style"
                onClick={goToTop}
            />
        )}{" "}
      </div> */}
      <NavbarNew />
      <HeroNew />

      <Snackbar
        open={alertState.open}
        autoHideDuration={
          alertState.hideDuration === undefined ? 6000 : alertState.hideDuration
        }
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};
}

const getCountdownDate = (
  candyMachine: CandyMachineAccount,
): Date | undefined => {
  if (
    candyMachine.state.isActive &&
    candyMachine.state.endSettings?.endSettingType.date
  ) {
    return toDate(candyMachine.state.endSettings.number);
  }

  return toDate(
    candyMachine.state.goLiveDate
      ? candyMachine.state.goLiveDate
      : candyMachine.state.isPresale
      ? new anchor.BN(new Date().getTime() / 1000)
      : undefined,
  );
};

export default Home;
